<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        label="Unidade"
                        :value="data.form.unidade"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        label="Local de atendimento"
                        :value="data.form.infraestrutura"
                        disabled
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="data.model.periodo"
                        :min-date="data.additionals.periodoMinDate"
                        :max-date="data.additionals.currentDate"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                </rkm-col>


                <rkm-col cols="6">
                    <rkm-form-input
                        label="Paciente"
                        v-model="data.model.paciente"
                        uppercase
                    />
                </rkm-col>


            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-select
                        label="Sexo"
                        :options="data.form.sexos"
                        v-model="data.model.sexoId"
                        value-field="id"
                        text-field="descricao"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        label="Data de nascimento"
                        v-model="data.model.dataNascimento"
                        :max-date="data.additionals.currentDate"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="FAA"
                        v-model="data.model.faa"
                        number
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :items="atendimentos"
            :fields="fields.tables.atendimentos"
            hide-filters
        >
            <template v-slot:cell(paciente)="{ item }">
                <rkm-button
                    :id="uniqueId(`paciente-icon-${item.atendimentoId}`)"
                    class="mr-2"
                    small
                >
                    <rkm-icon icon="user"/>
                </rkm-button>

                <rkm-popover
                    :target="uniqueId(`paciente-icon-${item.atendimentoId}`)"
                    triggers="hover"
                    placement="top"
                    title="Dados cadastrais"
                >
                    <div>
                        <span>
                            <strong>Prontuário:</strong> {{ item.pacienteProntuario }}
                        </span>
                    </div>

                    <div>
                        <span>
                            <strong>Data de nascimento:</strong> {{ item.pacienteDataNascimento }}
                        </span>
                    </div>

                    <div>
                        <span>
                            <strong>Nome da mãe:</strong> {{ item.pacienteNomeMae }}
                        </span>
                    </div>
                </rkm-popover>

                <span
                    :id="uniqueId(`paciente-nome-${item.atendimentoId}`)"
                    :class="{ 'text-primary': item.pacienteIsDesconhecido }"
                >
                    {{ item.pacienteNome }}

                    <template v-if="item.pacientePrefereNomeSocial">
                        <strong>({{ item.pacienteNomeSocial }})</strong>
                    </template>
                </span>

                <rkm-popover
                    v-if="item.pacienteIsDesconhecido"
                    :target="uniqueId(`paciente-nome-${item.atendimentoId}`)"
                    triggers="hover"
                    placement="top"
                    title="Características físicas"
                >
                    <span>
                        {{ item.pacienteCaracteristicasFisicas }}
                    </span>
                </rkm-popover>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :disabled="flg_processando == 1"
                    color="primary"
                    small
                    title="Imprimir"
                    @click="openFile(item.atendimentoId)"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

export default {
    computed: {
        fields() {

            return {
                tables: {
                    atendimentos: [
                        { key: 'data', label: 'Data', class: 'col-min' },
                        { key: 'faaNumero', label: 'FAA', class: 'col-min'  },
                        { key: 'sexo', label: 'Sexo', class: 'col-min'  },
                        { key: 'paciente', label: 'Paciente' },
                        { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                    ]
                }
            }
        },
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        }
    },
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('prontoAtendimento.impressaoFaaEletronica'),
            faaImpressao: this.getConectaSusRepository('impressao.prontoAtendimento')
        }
    },
    data: () => ({
        flg_processando : 0,
        atendimentos: []
    }),
    mixins: [repository, error, object, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        search() {

            this.setLoading()

            this.repositories.impressao.datatable(this.getSearchParams())
                .then(({ data }) => this.atendimentos = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.data.model)

            this.formateDates(params.periodo, ['start', 'end'], 'DD/MM/YYYY')
            this.formateDates(params, ['dataNascimento'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.data.model.periodo.start = this.clone(this.data.initials.model.periodo.start)
            this.data.model.periodo.end = this.clone(this.data.initials.model.periodo.end)
            this.data.model.setorId = this.data.initials.model.setorId
            this.data.model.sexoId = this.data.initials.model.sexoId
            this.data.model.paciente = this.data.initials.model.paciente
            this.data.model.dataNascimento = this.clone(this.data.initials.model.dataNascimento)
            this.data.model.faa = this.data.initials.model.faa

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        unlockLoading() {
            this.flg_processando = 0
            this.unsetLoading()
        },
        openFile(atendimentoId) {
            if(this.flg_processando == 1){
                 return
            }
            this.flg_processando = 1
            this.setLoading()

            this.repositories.faaImpressao.faa.eletronica(atendimentoId)
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unlockLoading())
        },
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>